import { pathOr } from 'ramda'
import {
  CLOSE_INACTIVITY_MODALS,
  CLOSE_INACTIVITY_MODALS_AFTER_LOGOUT
} from 'components/InactivityModal/constants'

import client, { disconnectCable } from 'apollo/client'
import { reconnectTicketedCable } from 'apollo/ticketedCable'
import {
  getFromStorage,
  setToStorage,
  removeFromStorage
} from 'utils/localStorage'
import config from 'constants/config'
import logger from 'utils/logger'
import REFRESH_SESSION from 'apollo/mutations/REFRESH_SESSION'
import { nicService } from 'stores/nic/services/nicService'

const { OKTA_REDIRECT } = config

export const getRefreshToken = getFromStorage('refresh')

export const signOut = async (preventRedirect = false) => {
  logger.logInfo('signOut')
  await nicService.signOutAndClear()
  await client.stop()
  await client.clearStore()
  disconnectCable()
  removeFromStorage('token')
  removeFromStorage('tokenExpiresAtIso')
  removeFromStorage('chatDrafts')
  removeFromStorage('lastUserActivityAt')
  if (preventRedirect !== true) {
    window.location.replace(OKTA_REDIRECT)
  }
}

// State-like variable to safeguard agains duplicate refresh requests
let refreshingSession = false

export const refreshSession = async (bySso = false, isIdle = false) => {
  if (refreshingSession) return false
  refreshingSession = true
  if (!isIdle) client.stop()

  const refreshToken = getRefreshToken()
  const r = await client.mutate({
    mutation: REFRESH_SESSION,
    context: {
      headers: {
        'X-Refresh-Token': refreshToken ? `Bearer ${refreshToken}` : ''
      }
    }
  })
  const newToken = pathOr('', ['data', 'refreshSession', 'token'], r)
  const tokenExpiresAtIso = pathOr(
    '',
    ['data', 'refreshSession', 'token_expires_at_iso'],
    r
  )

  refreshingSession = false
  if (!newToken) {
    return bySso
      ? pathOr(
          'Something went wrong: Failed to refresh session (Frontend)',
          ['data', 'refreshSession', 'message'],
          r
        )
      : signOut()
  }
  setToStorage('token')(newToken)
  setToStorage('tokenExpiresAtIso')(tokenExpiresAtIso)
  reconnectTicketedCable()
  const broadcastChannel = new BroadcastChannel('inactivity-broadcast')
  broadcastChannel.postMessage({
    type: bySso ? CLOSE_INACTIVITY_MODALS_AFTER_LOGOUT : CLOSE_INACTIVITY_MODALS
  })
  broadcastChannel.close()
  if (!isIdle && !bySso) {
    window.location.reload()
  }
  return true
}
